<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.text-center(v-if="!entity")
      v-col.py-0
        h2.primary--text No entity selected
        small.white--text Select an entity from the sidebar list.
    v-row(v-else)
      v-col.py-0
        v-card.px-10.py-5.my-5
          v-overlay(absolute, v-if="loading")
          g-data-table(
            dense,
            :headers="$fieldsToHeaders(entity, $fields(entity, 'primitive').filter(f => f.name !== 'localDownloadLink'))",
            :items="pagination.data",
            :options.sync="options",
            :server-items-length="pagination.total",
            v-bind="{ loading }",
          )
            template(v-slot:no-data)
              h2 {{ $replaceUnderscoreToSpace($pascalToHuman(entityName)) }} doesn't have items
              small Create an item for this entity or change search criteria.
            template(v-slot:top)
              app-entity-search(
                @pagination="pagination = $event",
                :loads="loads",
                :entity="entity",
              )
              //- app-entity-autocomplete(
                :entity="entity",
                :emit="true",
                v-model="where",
                @input="load()"
               )
            template(v-slot:item.action="{ item }")
              a(@click="downloadFile(item)", download)
                v-icon(small) mdi-download
              //- app-entity-delete(:title="item.name || entityName", @confirm="remove(item)", v-if="ShowEntityDelete(entityName)")
                template(v-slot:btn="{ on }")
                  v-icon(small, color="red", v-on="on") mdi-delete
    v-row
      v-snackbar(v-model="snackbar")
        | {{ message }}
        v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
import keys from 'lodash/keys'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import FileDownload from 'js-file-download';
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete
  },
  name: 'entity-index',
  mixins: [
    EntiyLoadsMixin,
    IndexFilterMixin,
  ],
  data:  function () {
    return {
      message: '',
      snackbar: false,
      loading: false,
      timer: null,
      wait: 500,
      pagination: {},
      options: {},
      loads: ['Order.User', 'Shipment.User', 'BusinessScope', 'DocumentRequest']
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.loads = _.get(ENV.ENTITIES, `${this.entityName}.index.add`, [])
          .filter(x => x.load)
          .map(x => x.load);
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    has () {
      return !!this.items.length
    },
    entityName () {
      return 'File'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    }
  },
  methods: {
    async downloadFile(file) {
      if (file != null && file.cloudStorageFileId != null) {
        this.$downloadFile(file, axios);
        return;
      }
      const { data } = await axios.get(file.localDownloadLink, { responseType: 'arraybuffer' });
      FileDownload(data, file.fileName);
    },
    getLink (uri) {
      return process.env.VUE_APP_API_ENDPOINT + uri
    },
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
          load: ['Order.User', 'Shipment.User', 'BusinessScope', 'DocumentRequest']
        }
      }
    },
    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          var criteria = this.$route.params.criteria ? { Where: [this.$route.params.criteria.value] } : null
          pagination.params = {...pagination.params, ...criteria}
          try {
            const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint', this.entityName);
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            pagination.params = _.merge(pagination.params, envParams);
            // this.loads = ['Order.User', 'Shipment.User']
            const paginationresult = (await axios.get(this.$fetchLoad(envEndpoint, ['Order.User', 'Shipment.User', 'BusinessScope', 'DocumentRequest']), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              // TODO: implement env ignoreTimezone here, find a way to make it generic.
              createdAt: moment(d.createdAt).format('YYYY-MM-DD HH:mm'),
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    /* TODO: docs */
    async remove (entity) {
      this.loading = true
      entity.entityState = ENV.ENTITY.STATE.DELETED
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.load(this.options)
    },

    getEditAttribute(item) {
      return _.get(item, _.get(ENV.ENTITIES, this.entityName  + '.index.editAttribute', 'uid'));
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    }
  },
  created() {

  }
}
</script>
